import { IGetState, TBoardId, TColorId } from '../../../types/types';
import { Dispatch, ThunkAction } from '../../../types/actions';
import { boardUserMetaSetRecentColorTags } from './boardUserMetaSetRecentColorTags';
import { getBoardUserMetaRecentColorTags } from '../../../store/model/board/selectors/getBoardUserMetaRecentColorTags';

export const boardUserMetaAddRecentColorTag = (
    boardId: TBoardId,
    recentColorTag: TColorId,
): ThunkAction => {
    const action = (
        dispatch: Dispatch,
        getState: IGetState
    ) => {
        const recentColorTags = [...getBoardUserMetaRecentColorTags(getState(), boardId), recentColorTag];
        return dispatch(boardUserMetaSetRecentColorTags(boardId, recentColorTags));
    };
    return action;
}
